import React, {Component} from 'react';
import {Grid} from 'react-bootstrap';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom'
import {Wrapper} from 'system/wrapper';
import {Image, Meta, Head, Content, Gallery, ImagesSection} from './components';
import Spinner from 'spinner';
import ReactModal from 'react-modal';
import {Modal, CloseModal, ModalContent, ModalImage} from 'components/modal';
import Breadcrumbs from '../breadcrumbs';
import {loadNewsDetail, loadTagsByNews, loadContentByNews} from 'redux/actions/portal/news';
import config from 'config';

import calendar from 'images/general/calendar.svg';
import close from 'images/general/close.svg';
import news from 'images/general/news.svg';

const mapStateToProps = state => ({
  detail: state.news.get('newsDetail'),
  images: state.news.get('newsContent'),
  isFetching: state.news.get('newsAreLoading'),

  tagsAreLoading: state.news.get('tagsByNewsAreLoading'),
  contentByNewsIsLoading: state.news.get('contentByNewsIsLoading')
});

const mapDispatchToProps = dispatch => ({
  onLoad: (id) => {
    dispatch(loadNewsDetail(id))
    dispatch(loadTagsByNews(id))
    dispatch(loadContentByNews(id))
  }
});

class NewsDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      image: null
    }
    this.onToggleModal = this.onToggleModal.bind(this);
  }

  onToggleModal(image) {
    this.setState({
      modalOpen: !this.state.modalOpen,
      image: image
    })
  }

  renderImageSection = () => {
    if (this.props.images && this.props.images.get('results').size) {
      return <ImagesSection>
        <h2>Галерея новини</h2>
        <Gallery>
          {this.props.images.get('results').map(image => (
            <li onClick={() => this.onToggleModal(image.get('file'))} key={image.get('id')}>
              <img src={image.get('file')} alt={image.get('name')}/>
            </li>
          ))}
        </Gallery>
      </ImagesSection>
    }
  }

  renderDatePublished = date => {
    return date
      ? new Date(date).toLocaleString('uk-UA', config.options)
      : 'Не опубліковано'
  }

   componentDidMount() {
    this.props.onLoad(this.props.match.params.id);
  }

  render() {

    const {detail, isFetching, images} = this.props;

    if (!detail || !images) {
      return <Spinner />
    }

    if (this.props.tagsAreLoading){
      return <Spinner/> 
    }

    if (this.props.contentByNewsIsLoading){
      return <Spinner/> 
    }

    return(
      <div> 
         <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/news">Новини</Link></li>
          <li><Link to={`/news/detail/${detail.get('id')}`}>Новина № {detail.get('id')}</Link></li>
        </Breadcrumbs>
        <Wrapper>
          {isFetching ? (
            <Spinner />
          ):(
            <Grid>
              <Image>
                <img src={detail.get('image') ? detail.get('image') : news} alt="news" />
              </Image>
              <Meta>
                <img src={calendar} alt="calendar" />
                <span>{this.renderDatePublished(detail.get('date_published'))}</span>
                {detail.get('tag_list').map((tag, i) => (
                  <span key={i}>{tag.get('tag_data').get('title')}</span>
                ))}
              </Meta>
              <Head>
                <h4>{detail.get('title')}</h4>
              </Head>
              <Content>
                <p><div dangerouslySetInnerHTML={{
										__html: detail.get('detail_description')
									}}></div></p>
              </Content>
              {this.renderImageSection()}

            </Grid>
          )}
        </Wrapper>
        <ReactModal isOpen={this.state.modalOpen} onRequestClose={this.onToggleModal}
          className={{
            base: 'modalGallery',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>
          <Modal>
            <CloseModal>
              <div  onClick={(event) => this.onToggleModal()}>
				         <img src={close} alt="закрити" />
              </div>
						</CloseModal>
            <ModalContent>
              <ModalImage>
                <img src={this.state.image} alt="" />
              </ModalImage>
            </ModalContent>
          </Modal>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewsDetail);



// WEBPACK FOOTER //
// ./src/system/news/detail.js